import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate";
import AuthRepository from "../repositories/Auth/AuthRepository";
import AccountRepository from "../repositories/Account/AccountRepository";

const store = new Vuex.Store({
    state: {
        loading: {
          full_page: 0,
          content: 0,
          local: 0,
        },

        admin: {
            video_upload_progress: 0
        },

        language: 'lb',
        user: null,
        notifications: [],
        last_navigation_at: null,

        settings: {
            livestream_online: false
        },

        cancelTokens: [],
    },
    getters: {
        cancelTokens: state => {
            return state.cancelTokens;
        },
        isAuthenticated: state => {
            return state.user !== null;
        },
        isSubscribed: state => {
            return state.user === null ? false : (state.user.is_subscribed || state.user.is_admin);
        },
        isAdmin: state => {
            return state.user === null ? false : state.user.is_admin;
        },
        user: state => {
            return state.user;
        },
        shouldFetchAuthDetails: state => {
            // Fetches Auth Details every 15 seconds
            return state.user !== null && (Math.floor(Date.now() / 1000) - state.last_navigation_at >= 15) // 15 Seconds
        },
        shouldLoadFullPage: state => state.loading.full_page > 0,
        shouldLoadContent: state => state.loading.content > 0,
        shouldLoadLocal: state => state.loading.local > 0,
        isExecutingRequest: state => state.loading.full_page > 0 || state.loading.content > 0 || state.loading.local > 0,
        notifications: state => state.notifications,

        isLiveStreamOnline: state => state.settings?.livestream_online || false,
    },
    mutations: {
        ADD_CANCEL_TOKEN(state, token) {
            state.cancelTokens.push(token);
        },
        CLEAR_CANCEL_TOKENS(state) {
            state.cancelTokens = [];
        },
        addRequestToLoadingStack(state, type) {
            switch(type) {
                case "full_page":
                    state.loading.full_page++;
                    break;
                case "content":
                    state.loading.content++;
                    break;
                case "local":
                    state.loading.local++;
                    break;
            }
        },
        removeRequestFromLoadingStack(state, type) {
            switch(type) {
                case "full_page":
                    if(state.loading.full_page > 0) {
                        state.loading.full_page--;
                    }
                    break;
                case "content":
                    if(state.loading.content > 0) {
                        state.loading.content--;
                    }
                    break;
                case "local":
                    if(state.loading.local > 0) {
                        state.loading.local--;
                    }
                    break;
            }
        },
        changeLanguage(state, lang) {
            if(["en", "de", "lb"].includes(lang)) {
                state.language = lang;
            } else {
                state.language = "en";
            }
        },
        resetLoadingStack(state) {
            state.loading.full_page = 0;
            state.loading.content = 0;
            state.loading.local = 0;
        },
        authenticate(state, data) {
            state.user              = data.user;
            state.notifications     = data.notifications;

            state.language          = data.user.preferred_language;
        },
        updateUserData(state, data) {
            state.user = data;
            state.language = data.preferred_language;
        },
        setAuthInfo(state, data) {
            state.user              = data.user;
            state.notifications     = data.notifications;
            state.language          = data.user.preferred_language;
        },
        logout(state) {
            state.user = null;
            state.loading = {
                full_page: 0,
                content: 0,
            };
            state.admin = {
                video_upload_progress: 0
            };

            state.notifications = [];

            state.settings = {
                livestream_online: false
            };
        },
        changeRoute(state) {
            state.last_navigation_at = Math.floor(Date.now() / 1000);
        },
        setVideoUploadProgress(state, progress = 0) {
            state.admin.video_upload_progress = progress;
        },
        setSettings: (state, settings) => state.settings = settings,
        setNotifications: (state, notifications) => state.notifications = notifications,
    },
    actions: {
        CANCEL_PENDING_REQUESTS(context) {
            // Cancel all request where a token exists
            context.state.cancelTokens.forEach((request, i) => {
                if(request.cancel){
                    request.cancel();
                }
            });

            // Reset the cancelTokens store
            context.commit('CLEAR_CANCEL_TOKENS');
        },
        login ({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                AuthRepository.login(credentials)
                    .then((response => {
                        commit('authenticate', response.data);
                        resolve(response);
                    })).catch(error => {
                    reject(error);
                });
            })
        },
        register ({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                AuthRepository.createAccount(credentials)
                    .then((response => {
                        commit('authenticate', response.data);
                        resolve(response);
                    })).catch(error => {
                    reject(error);
                });
            })
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                AuthRepository.logout()
                    .then((response => {
                        commit('logout');
                        resolve(response);
                    })).catch(error => {
                        //commit('logout');
                        reject(error);
                });
            })
        },
        updateUserData ({ commit }) {
            return new Promise((resolve, reject) => {
                AccountRepository.getData()
                    .then((response => {
                        commit('updateUserData', response.data);
                        resolve(response);
                    })).catch(error => {
                    reject(error);
                });
            })
        },

    },
    plugins: [createPersistedState()],
});

export default store;
